import React, { useState, useRef, useEffect } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


function SampleNextArrow(props) {
    const { className, style, onClick } = props;

    return (
        <div
            className={className}
            style={{ background: "url('../assets/images/rightarrow.svg') no-repeat", backgroundSize: '100% 100%' }}
            onClick={onClick}
        />
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ background: "url('../assets/images/leftarrow.svg') no-repeat", backgroundSize: '100% 100%' }}
            onClick={onClick}
        />
    );
}



const ImageSlide = (props) => {
    const sliderRef = useRef();
    const [activeIndex, setActiveIndex] = useState('1')
    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        afterChange: (index) => { setActiveIndex(index + 1) },
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />
    };

    useEffect(() => {
        if (props.activeIndex) {
            sliderRef.current.slickGoTo((parseInt(props.activeIndex)));
            setActiveIndex(parseInt(props.activeIndex) + 1)

        }

    }, [])
    let image = props.images
    return (
        <>
            <div className="popupslide_bg">
                <span className="cross_icon">
                    <img src="/assets/images/cross.svg" alt="" onClick={() => { props.hideSlide() }} />
                </span>
                <div className="popup_image">

                    <Slider {...settings} ref={sliderRef}>
                        {image && image.map((imageitem, index) => {
                            return (
                                <div key={index}>
                                    <div className="img_padding">
                                        <img src={imageitem} alt="" />
                                    </div>
                                </div>
                            )
                        })}

                        {/* 
                        <div>
                            <img src="/assets/images/img-4.jpg" alt="" />
                        </div>

                        <div>
                            <img src="/assets/images/img-4.jpg" alt="" />
                        </div>

                        <div>
                            <img src="/assets/images/img-4.jpg" alt="" />
                        </div>

                        <div>
                            <img src="/assets/images/img-4.jpg" alt="" />
                        </div> */}
                    </Slider>

                    <h6><span>{activeIndex}</span> / {image.length}</h6>
                </div>
            </div>
        </>
    )
}

export default ImageSlide;